import React, { PropsWithChildren } from 'react'
import { ActionModule } from '@typesApp/ActionModule'
import { HostEnvironment } from '@typesApp/Environment'
import { CustomerContext } from '@typesApp/Customer'
import { WidgetContextHolder } from '@typesApp/WidgetContextHolder'
import { WidgetContext } from '@components/widgetContext/context'
import { useAppInit } from './hooks/useAppInit'

export type AppProps = PropsWithChildren & {
  widgetContext?: WidgetContextHolder
}

export type AppWithConfigurationProps = PropsWithChildren & {
  environment: HostEnvironment
  actionModule: ActionModule
  customerContext: CustomerContext
  widgetContext?: WidgetContextHolder
}

export const AppHOC: React.FC<AppProps> = props => {
  const { widgetContext } = props

  return <WidgetContext.Provider value={widgetContext ?? {}}>{props.children}</WidgetContext.Provider>
}

export const AppWithConfigurationHOC: React.FC<AppWithConfigurationProps> = props => {
  const { customerContext, environment, actionModule, widgetContext } = props
  useAppInit({ customerContext, environment, actionModule })

  return <WidgetContext.Provider value={widgetContext ?? {}}>{props.children}</WidgetContext.Provider>
}
